// Use environment variable, dev-safe default for local, or production URL
export const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://listings.pxnres.com");
export const ASSETS_BASE_URL = "https://listing-iq-assets.s3.amazonaws.com";
// Public samples served from our own domain rather than a raw S3 URL under the
// old brand. The objects live in the website bucket under demo/ and are
// excluded from the deploy sync's --delete, so a build never removes them.
export const DEMO_REPORT_URL = "https://listino.ai/demo/fullreport";
export const DEMO_STAGING_URL = "https://listino.ai/demo/stagingplan";

// Log API URL in development for debugging
if (process.env.NODE_ENV === "development") {
  console.log("API URL:", API_URL);
}
